import { render, staticRenderFns } from "./themes.vue?vue&type=template&id=c3157da4&scoped=true"
import script from "./themes.vue?vue&type=script&lang=js"
export * from "./themes.vue?vue&type=script&lang=js"
import style0 from "./themes.vue?vue&type=style&index=0&id=c3157da4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3157da4",
  null
  
)

export default component.exports